export default {
    en: {
        language: '',
        title: 'Asset name',
        activity: 'Activity',
        chart: 'Chart',
        price: 'Cost, USDT',
        change: '24h change',
        month_max: 'Monthly high',
        month_min: 'Monthly low',
        year_max: 'Annual high',
        year_min: 'Annual low',
        allTime_max: 'Historical high',
        allTime_min: 'Historical low',
        volatility: 'High volatility',
        volatility_end: 'Volatility ended',
        ago: '{COUNT}h ago',
        last: 'Last {COUNT}h',
        buy: 'Buy',
        trade: 'Trade',
        link: 'All trading assets'
    },
    ru: {
        language: 'ru',
        title: 'Актив',
        activity: 'Активность',
        chart: 'График',
        price: 'Цена в USDT',
        change: 'Изменение за сутки',
        month_max: 'Месячный макс.',
        month_min: 'Месячный мин.',
        year_max: 'Годовой макс.',
        year_min: 'Годовой мин.',
        allTime_max: 'Абсолютный макс.',
        allTime_min: 'Абсолютный мин.',
        volatility: 'Высокая волатильность',
        volatility_end: 'Волатильность закончилась',
        ago: '{COUNT}ч. назад',
        last: 'Последние {COUNT}ч.',
        buy: 'Купить',
        trade: 'Торговать',
        link: 'Все торговые активы'
    },
    es: {
        language: 'es-es',
        title: 'Nombre del activo',
        activity: 'Actividad',
        chart: 'Gráfica',
        price: 'Coste, USDT',
        change: 'Cambio 24h',
        month_max: 'Alto mensual',
        month_min: 'Bajo mensual',
        year_max: 'Alto anual',
        year_min: 'Bajo anual',
        allTime_max: 'Alto absoluto',
        allTime_min: 'Bajo absoluto',
        volatility: 'Alta volatilidad',
        volatility_end: 'La volatilidad terminó hace',
        ago: '{COUNT} horas',
        last: 'Últimas {COUNT} h',
        buy: 'Comprar',
        trade: 'Opera',
        link: 'Todos los activos de trading'
    },
    es_ES: {
        language: 'es-es',
        title: 'Nombre del activo',
        activity: 'Actividad',
        chart: 'Gráfico',
        price: 'Cost, USDT',
        change: 'Cambio 24h',
        month_max: 'Alto mensual',
        month_min: 'Bajo mensual',
        year_max: 'Alto anual',
        year_min: 'Bajo anual',
        allTime_max: 'Alto absoluto',
        allTime_min: 'Bajo absoluto',
        volatility: 'Alta volatilidad',
        volatility_end: 'La volatilidad terminó hace',
        ago: '{COUNT} horas',
        last: 'Últimas {COUNT} h',
        buy: 'Comprar',
        trade: 'Opera',
        link: 'Todos los activos de trading'
    },
    de: {
        language: 'de',
        title: 'Vermögenswert',
        activity: 'Aktivität',
        chart: 'Chart',
        price: 'Kurs, USDT',
        change: 'Änderung 24h',
        month_max: 'Monatshoch',
        month_min: 'Monatstief',
        year_max: 'Jahreshoch',
        year_min: 'Jahrestief',
        allTime_max: 'Allzeithoch',
        allTime_min: 'Allzeittief',
        volatility: 'Hohe Volatilität',
        volatility_end: 'Volatilität endete',
        ago: 'vor {COUNT} Std',
        last: 'Letzt {COUNT} Std',
        buy: 'Kaufen',
        trade: 'Handeln',
        link: 'Alle Vermögenswerte'
    },
    fr: {
        language: 'fr',
        title: "Nom de l'actif",
        activity: 'Activité',
        chart: 'Graphique',
        price: 'Coût, USDT',
        change: 'Changements sur 24h',
        month_max: 'Plus haut mensuel',
        month_min: 'Plus bas mensuel',
        year_max: 'Plus haut annuel',
        year_min: 'Plus bas annuel',
        allTime_max: 'Plus haut absolu',
        allTime_min: 'Plus bas absolu',
        volatility: 'Volatilité élevée',
        volatility_end: 'La volatilité a pris fin',
        ago: 'il y a {COUNT} h',
        last: 'Dernières {COUNT} h',
        buy: 'Acheter',
        trade: 'Échanger',
        link: 'Tous les actifs de trading'
    },
    nl: {
        language: 'nl',
        title: 'Actvivanaam',
        activity: 'Activiteit',
        chart: 'Grafiek',
        price: 'Kosten, USDT',
        change: '24u wijziging',
        month_max: 'Maandelijks hoog',
        month_min: 'Maandelijks laag',
        year_max: 'Jaarlijks hoog',
        year_min: 'Jaarlijks laag',
        allTime_max: 'Absoluut hoog',
        allTime_min: 'Absoluut laag',
        volatility: 'Hoge volatiliteit',
        volatility_end: 'Volatiliteit eindigde',
        ago: '{COUNT} u geleden',
        last: 'Laatste {COUNT} u',
        buy: 'Kopen',
        trade: 'Transactie',
        link: 'Alle handelsactiva'
    },
    it: {
        language: 'it',
        title: 'Nome asset',
        activity: 'Attività',
        chart: 'Grafico',
        price: 'Costo, USDT',
        change: 'Modifica 24h',
        month_max: 'Massimo mensile',
        month_min: 'Minimo mensile',
        year_max: 'Massimo annuale',
        year_min: 'Minimo annuale',
        allTime_max: 'Massimo assoluto',
        allTime_min: 'Minimo assoluto',
        volatility: 'Alta volatilità',
        volatility_end: 'La volatilità è terminata',
        ago: '{COUNT} ore fa',
        last: 'Ultime {COUNT} ore',
        buy: 'Acquistare',
        trade: 'Operazione',
        link: 'Tutti gli asset di trading'
    },
    pt: {
        language: 'pt',
        title: 'Nome do ativo',
        activity: 'Atividade',
        chart: 'Gráfico',
        price: 'Custo, USDT',
        change: 'Alteração 24h',
        month_max: 'Alta mensal',
        month_min: 'Baixa mensal',
        year_max: 'Alta anual',
        year_min: 'Baixa anual',
        allTime_max: 'Alta absoluta',
        allTime_min: 'Baixa absoluta',
        volatility: 'Elevada volatilidade',
        volatility_end: 'Volatilidade finda',
        ago: 'há {COUNT}h',
        last: 'Últimas {COUNT}h',
        buy: 'Comprar',
        trade: 'Negociar',
        link: 'Todos os ativos de negociação'
    },
    pt_BR: {
        language: 'pt-br',
        title: 'Nome do ativo',
        activity: 'Atividade',
        chart: 'Gráfico',
        price: 'Custo, USDT',
        change: 'Alterar 24h',
        month_max: 'Alto mensal',
        month_min: 'Baixo mensal',
        year_max: 'Alto anual',
        year_min: 'Baixo anual',
        allTime_max: 'Alto absoluto',
        allTime_min: 'Baixo absoluto',
        volatility: 'Alta volatilidade',
        volatility_end: 'Volatilidade encerrad',
        ago: '{COUNT}h atrás',
        last: 'Últimas {COUNT}h',
        buy: 'Comprar',
        trade: 'Negociar',
        link: 'Todos os ativos de trading'
    },
    pl: {
        language: 'pl',
        title: 'Nazwa aktywa',
        activity: 'Aktywność',
        chart: 'Wykres',
        price: 'Koszt, USDT',
        change: 'Zmiana 24h',
        month_max: 'Miesięczny szczyt',
        month_min: 'Miesięczny dołek',
        year_max: 'Roczny szczyt',
        year_min: 'Roczny dołek',
        allTime_max: 'Absolutny szczyt',
        allTime_min: 'Absolutny dołek',
        volatility: 'Wysoka zmienność',
        volatility_end: 'Zmienność zakończyła się',
        ago: '{COUNT}h temu',
        last: 'Ostatnie {COUNT}h',
        buy: 'Kup',
        trade: 'Handluj',
        link: 'Wszystkie aktywa handlowe'
    },
    tr: {
        language: 'tr',
        title: 'Varlık adı',
        activity: 'Aktivite',
        chart: 'Grafik',
        price: 'Maliyet, USDT',
        change: 'Değişim 24s',
        month_max: 'Aylık yüksek',
        month_min: 'Aylık düşük',
        year_max: 'Yıllık yüksek',
        year_min: 'Yıllık düşük',
        allTime_max: 'En yüksek',
        allTime_min: 'En düşük',
        volatility: 'Yüksek volatilite',
        volatility_end: 'Volatilite',
        ago: '{COUNT} sa önce sona erdi',
        last: 'Son {COUNT} sa',
        buy: 'Al',
        trade: 'Pozisyon',
        link: 'Tüm varlıklar'
    },
    vi: {
        language: 'vi',
        title: 'Tài sản',
        activity: 'Hoạt động',
        chart: 'Biểu đồ',
        price: 'Phí, USDT',
        change: 'Thay đổi 24 giờ',
        month_max: 'Cao nhất tháng',
        month_min: 'Thấp nhất tháng',
        year_max: 'Cao nhất năm',
        year_min: 'Thấp nhất năm',
        allTime_max: 'Cao tuyệt đối',
        allTime_min: 'Thấp tuyệt đối',
        volatility: 'Biến động lớn',
        volatility_end: 'Hết biến động',
        ago: '{COUNT}h trước',
        last: '{COUNT}h qua',
        buy: 'Mua',
        trade: 'Giao dịch',
        link: 'Tất cả tài sản giao dịch'
    },
    zh_CN: {
        language: 'cn',
        title: '资产名称',
        activity: '动态',
        chart: '图表',
        price: '价格（以USDT计）',
        change: '24h 涨跌',
        month_max: '当月最高',
        month_min: '当月最低',
        year_max: '年度最高',
        year_min: '年度最低',
        allTime_max: '绝对高点',
        allTime_min: '绝对低点',
        volatility: '高波动性',
        volatility_end: '波动性于',
        ago: '{COUNT} 小时前结束',
        last: '持续 {COUNT} 小时',
        buy: '买入',
        trade: '交易',
        link: '所有交易资产'
    },
    zh_TW: {
        language: 'cn',
        title: '資產名稱',
        activity: '動態',
        chart: '圖表',
        price: '價格（以USDT計）',
        change: '24h 漲跌',
        month_max: '當月最高',
        month_min: '當月最低',
        year_max: '年度最高',
        year_min: '年度最低',
        allTime_max: '絕對高點',
        allTime_min: '絕對低點',
        volatility: '高波動性',
        volatility_end: '波動性與',
        ago: '{COUNT} 小時前結束',
        last: '持續 {COUNT} 小時',
        buy: '買入',
        trade: '交易',
        link: '所有交易資產'
    }
}
